module.exports = __webpack_public_path__ + "static/img/1_0_1.39fa279e.jpg";